var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddInputfield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4011_416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79998 4H7.20002V7.20002H4V8.79998H7.20002V12.0001H8.79998V8.79998H12V7.20002H8.79998V4ZM12.8 0H3.20002C1.43265 0 0 1.43277 0 3.20002V12.8C0 14.5673 1.43265 16 3.20002 16H12.8C14.5673 16 16 14.5673 16 12.8V3.20002C16 1.43277 14.5673 0 12.8 0ZM14.4 12C14.4 13.3254 13.3256 14.4 12.0001 14.4H4C2.67456 14.4 1.60007 13.3256 1.60007 12V4C1.60007 2.67456 2.67456 1.59995 4 1.59995H12.0001C13.3256 1.59995 14.4 2.67444 14.4 4V12Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4011_416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInputfield);
export default __webpack_public_path__ + "static/media/AddInputfield.2c5da85d3d9d59f4eb231cbef67d4e57.svg";
export { ForwardRef as ReactComponent };